// Autor: Prof. Emmanuel Ponce de León
// Sitio: Biblioteca FFyL - UNCuyo
// Año: 2025

import React from "react";
import '../../styles/components/layout/Footer.css';


const Footer = (props) => {
    return (
        <footer>
            <div className="container-fluid">
                <p>Biblioteca FFyL - UNCuyo</p>
            </div>
        </footer>
    );
}

export default Footer;